import React, { useState } from 'react';

import ENUMS from '../../enums';
import ShowForPermission from '../../components/ShowForPermission';
import EditResponse from './modal/EditResponse';
import styles from './styles.scss';

const Response = props => {
  const [editResponseModalIsOpen, setEditResponseModalIsOpen] = useState(false);

  const displayEditModal = e => {
    e.preventDefault();
    setEditResponseModalIsOpen(true);
  };

  const closeEditModal = () => {
    setEditResponseModalIsOpen(false);
  };

  return (
    <div className="col-12 p-0 d-flex justify-content-end">
      <div className="card my-3 col-5 px-0">
        <div
          className={`card-header text-white ${
            props.response.responder === 'آرسی' ? 'bg-primary' : 'bg-info'
          }`}
        >
          {props.response.createdAt}
        </div>
        <div className={`card-body text-success d-flex flex-wrap ${styles.commentText}`}>
          {props.response.message}
        </div>
        <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_COMMENT}>
          <div className="card-footer d-flex p-0 py-2">
            <button
              // onClick={() => displayEditModal(props.comment, props.response)}
              onClick={displayEditModal}
              className="btn btn-info mx-1"
            >
              {locales('titles.edit')}
            </button>
          </div>
        </ShowForPermission>
      </div>
      <div className="d-flex flex-column justify-content-start px-3 my-4 align-items-center">
        <img
          className="img-circle rounded-circle border userCommentsAvatar"
          src={
            props.response.userAvatar && props.response.userAvatar.length
              ? props.response.userAvatar
              : require('../../assets/icons/userDefault.png')
          }
        />
        <div className={styles.responderFullName}>
          {props.response.userFullName}
          <p>(پاسخ {props.response.responder})</p>
        </div>
      </div>

      {editResponseModalIsOpen && (
        <EditResponse
          isOpen={editResponseModalIsOpen}
          commentId={props.response.id}
          commentText={props.response.message}
          close={closeEditModal}
        />
      )}
    </div>
  );
};

export default Response;
